angular.module('app').component('objectWindow', {
    templateUrl: 'js/components/object-window/index.html?cache=4',
    controller: ObjectWindowController,
    controllerAs: '$ow',
    bindings: {
        object: '<',
        api: '<',
    },
});

ObjectWindowController.$inject = [];

function ObjectWindowController() {
    var $ctrl = this;
    $ctrl.tab = 1;

    $ctrl.TAB_MAIN = 1;
    $ctrl.TAB_CAN = 2;
    $ctrl.TAB_TACHOGRAPH = 3;

    $ctrl.tachograph = {
        analysis: false,
    };

    $ctrl.ready = false;
    $ctrl.modes = [];

    $ctrl.childs = [];

    $ctrl.isTab = function(tab) {
        return $ctrl.tab === tab;
    };

    $ctrl.$onInit = function() {
        if (!$ctrl.api) {
            return false;
        }

        $ctrl.api.call.change = $ctrl.onObjectDataChanges;

        $ctrl.ready = true;
        $ctrl.modes = $ctrl.api.data.modes;
    };

    $ctrl.last = false;

    $ctrl.onObjectDataChanges = function() {
        if (!$ctrl.api || ($ctrl.object || {}).id === void 0) {
            return false;
        }

        for (var i in $ctrl.childs) {
            var child = $ctrl.childs[i];

            if (child.onObjectDataChanged !== void 0) {
                child.onObjectDataChanged();
            }
        }
    };

    $ctrl.$onChanges = function() {
        if (!$ctrl.api || ($ctrl.object || {}).id === void 0) {
            return false;
        }

        if ($ctrl.last !== $ctrl.object.id) {
            for (var i in $ctrl.childs) {
                var child = $ctrl.childs[i];

                if (child.onObjectChanged !== void 0) {
                    child.onObjectChanged();
                }
            }
            $ctrl.setMainTab();
        }

        $ctrl.last = $ctrl.object.id;
    };

    $ctrl.isModeTurnedOn = function(mode) {
        return $ctrl.modes.length ? $ctrl.modes.indexOf(mode) >= 0 : false;
    };

    $ctrl.isOWCardsAvailable = function() {
        return (
            $ctrl.isModeTurnedOn('tachograph') &&
            $ctrl.object &&
            ($ctrl.object.has.tachograph || $ctrl.object.has.iButton)
        );
    };

    $ctrl.isTachographAvailable = function() {
        return $ctrl.isModeTurnedOn('tachograph') && $ctrl.object && $ctrl.object.has.tachograph;
    };

    $ctrl.setMainTab = function() {
        var main = $ctrl.isOWCardsAvailable() ? $ctrl.TAB_TACHOGRAPH : $ctrl.TAB_MAIN;
        $ctrl.changeTab(main);
    };

    $ctrl.changeTab = function(tab) {
        $ctrl.tab = tab;
        $ctrl.api.on.resize();
    };

    $ctrl.dismiss = function() {
        $ctrl.api.fn.close();
        $ctrl.api.on.resize();
    };
}
